// import LayoutChild from "@/layouts/LayoutChild.vue";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [
  {
    path: "/traffic",
    name: "traffic",
    meta: {
      title: "出行服务",
      icon: require('@/assets/images/icons/zuzhi.png')
      // link: "https://road.hncd.gov.cn/",
      // hidden: true,
    },
    // component: LayoutArticle,
    component: () => import("@/views/traffic/index.vue"),
    // redirect: "/traffic/index",
    children: [
      {
        path: "/traffic/lukuangxinxi",
        name: "lukuangxinxi",
        meta: {
          title: "路况信息",
          icon: require('@/assets/images/icons/zuzhi.png')
        },
        component: () => import("@/views/traffic/components/lukuangxinxi.vue"),
      },
      // {
      //   path: "/traffic/dituchaxun",
      //   name: "dituchaxun",
      //   meta: {
      //     title: "地图查询",
      //     icon: require('@/assets/images/icons/zuzhi.png')
      //   },
      // },
    ],
  },
  {
    path: "/traffic-detail",
    name: "traffic-detail",
    meta: {
      title: "出行服务",
      hidden: true,
      icon: require('@/assets/images/icons/zuzhi.png')
    },
    component: LayoutArticle,
    redirect: "/traffic/detail",
    children: [{
      path: "/traffic/detail",
      name: "traffic_detail",
      meta: {
        title: "详情",
        hidden: true,
      },
      component: () => import("@/views/traffic/detail.vue"),
    },],
  },
];
